import { __extends } from "tslib";
import { Plot } from '../../core/plot';
import { adaptor, statistic } from './adaptor';
import { getLiquidData } from './utils'; // register liquid shape

import './shapes/liquid';
/**
 * 传说中的水波图
 */

var Liquid =
/** @class */
function (_super) {
  __extends(Liquid, _super);

  function Liquid() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** 图表类型 */


    _this.type = 'liquid';
    return _this;
  }

  Liquid.prototype.getDefaultOptions = function () {
    return {
      color: '#6a99f9',
      radius: 0.9,
      statistic: {
        title: false,
        content: {
          formatter: function formatter(_a) {
            var percent = _a.percent;
            return (percent * 100).toFixed(2) + "%";
          },
          style: {
            opacity: 0.75,
            fontSize: '30px',
            lineHeight: '30px',
            textAlign: 'center'
          }
        }
      },
      outline: {
        border: 2,
        distance: 0
      },
      wave: {
        count: 3,
        length: 192
      }
    };
  };
  /**
   * 更新数据
   * @param percent
   */


  Liquid.prototype.changeData = function (percent) {
    this.updateOption({
      percent: percent
    });
    this.chart.data(getLiquidData(percent));
    statistic({
      chart: this.chart,
      options: this.options
    }, true);
  };
  /**
   * 获取适配器
   */


  Liquid.prototype.getSchemaAdaptor = function () {
    return adaptor;
  };

  return Liquid;
}(Plot);

export { Liquid };